import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this._handleKeydown = (e) => {
      if (e.key === "Escape") this.close()
    }
  }

  open() {
    this.panelTarget.classList.remove("invisible", "translate-x-full")
    if (this.hasBackdropTarget) this.backdropTarget.classList.remove("hidden")
    document.documentElement.classList.add("overflow-hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this._handleKeydown)
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("hidden")
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._handleKeydown)
    setTimeout(() => this.panelTarget.classList.add("invisible"), 300)
  }

  backdropClose(event) {
    if (event.target === this.backdropTarget) this.close()
  }

  disconnect() {
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("hidden")
    if (this.hasPanelTarget) this.panelTarget.classList.add("invisible", "translate-x-full")
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._handleKeydown)
  }
}
